import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';

TemplatesCreateFlexpayController.$inject = ['$scope', '$state', '$timeout', 'ApiService', 'TemplatesService'];

function TemplatesCreateFlexpayController(
  $scope: IScope & { templatesCreateFlexpay: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  TemplatesService: TODO
) {
  const ctrl = {
    model: [],
    template: {},
    mode: 'create',
    isLoaded: false,
    lastUpdated: false,
    lastPublished: false,
    admissionTypes: TemplatesService.admissionTypes,

    grid: {
      pageSize: 50,
      paginate: true,
      showFooter: true,
      multiselect: false,
      enableRowSelection: false,
      columns: [
        {
          field: 'edit',
          displayName: 'Edit',
          width: 50,
          onCellNavClick: (row, col) => {
            ctrl.gridDoubleClick(row);
          },
          cellTemplate:
            '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onGridDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'name',
          displayName: 'Name',
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'effectiveDates',
          displayName: 'Effective',
        },
        {
          field: 'repeatCycle',
          displayName: 'Occurs',
        },
        {
          field: 'hours',
          displayName: 'Hours',
        },
        {
          field: 'type',
          displayName: 'Type',
        },
      ],
    },

    init: function () {
      if ($state.params && $state.params.id) {
        ctrl.mode = 'edit';
        // next tick
        $timeout(() => {
          ctrl.model = TemplatesService.flexpay.getSchedulesList();
          ctrl.isLoaded = true;
        }, 0);
      } else {
        ctrl.model = TemplatesService.flexpay.getSchedulesList();
        ctrl.isLoaded = true;
      }
      ctrl.template = TemplatesService.getModel();

      TemplatesService.setIsTabLoading(false, 'flexpay');

      $scope.$on('TemplatesService::Update', ctrl.onTemplatesServiceUpdate);
    },

    getFlexpaySchedules: function () {
      // TODO: Integrate with standalone API
    },

    gridDoubleClick: function (row) {
      $state.go('application.templates.edit.flexpay.edit.schedule', { scheduleId: row.entity.id });
    },

    success: {
      init: function (response) {},
      getFlexpaySchedules: function (response) {},
    },

    error: {
      init: function (response) {},
      getFlexpaySchedules: function (response) {},
    },

    onTemplatesServiceUpdate: function (e, data) {
      ctrl.model = TemplatesService.flexpay.getSchedulesList();
      ctrl.template = TemplatesService.getModel();

      ctrl.isLoaded = true;
    },
  };

  $scope.templatesCreateFlexpay = ctrl;
  ctrl.init();
}

export const TemplatesCreateFlexpayControllerModule = angular
  .module('acme.view.application.templates.create.flexpay.controllers', [
    'ui.router',
    'acme.common.service.api',
    'acme.common.service.templates',
  ])
  .controller('TemplatesCreateFlexpayController', TemplatesCreateFlexpayController).name;
